export default {
  data() {
    return {
      scrollFlag: false,
      filterFlag: false,
      isEnd: false,
      // 分页
      pageNum: 1,
      total: 0,
      itemList: [],
      includeList: [], // 收录
      yearList: [], // 年份
      beginDateTime: '',
    };
  },
  mounted() {
    this.$bus.$on("mainScroll", this.handlePager);
  },
  beforeDestroy() {
    this.$bus.$off("mainScroll", this.handlePager);
  },
  methods: {
    handlePager() {
      let containerHeight =
        document.documentElement.clientHeight +
        document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      if (containerHeight + 1 >= scrollHeight && !this.scrollFlag && !this.isEnd) {
        if (this.filterFlag) {
          this.getItemList({
            ...this.params,
            pageNo: ++this.pageNum,
          });
        } else {
          this.getItemList({
            ...this.params,
            pageNo: ++this.pageNum,
          });
        }
      }
    },
    async getItemList(data) {
      if (data.pageNo == 1) this.beginDateTime = this.$global.transferDate(new Date()); //增加请求列表时间戳,请求第一页时的时间,防止新增文章时请求列表出现重复
      // 重新加密
      if (sessionStorage.getItem("trip") == null) {
        let { pk } = await this.$apis.mainServe.getPk();
        sessionStorage.setItem("trip", pk);
      }
      this.scrollFlag = true;
      this.isEnd = false;
      const resp = await this.$apis.mainServe.getListByChannel({
        pageSize: 5,
        ...data,
        beginDateTime: this.beginDateTime,
        channelId1: this.$route.query.id,
        projectId: JSON.parse(sessionStorage.getItem("Table"))
          ? JSON.parse(sessionStorage.getItem("Table")).PlatformEnum[0].id
          : 1,
      });
      this.total = +resp.data.total;
      this.itemList.push(...resp.data.list);
      this.scrollFlag = false;
      let num = data.pageSize ? data.pageSize : 5
      this.isEnd = this.pageNum >= this.total / num;
    },
    handleSub(v) {
      this.filterFlag = true;
      if (this.filterFlag) {
        this.pageNum = 1;
        this.itemList = [];
      }
      this.params.classifyNumber = v.classifyNumber;
      this.getItemList({
        ...this.params,
      });
    },
    handleInclude(id) {
      this.filterFlag = true;
      if (this.filterFlag) {
        this.pageNum = 1;
        this.itemList = [];
      }
      this.params.dataStyleId = id;
      this.getItemList({
        ...this.params,
      });
    },
    handleYear(item) {
      this.filterFlag = true;
      if (this.filterFlag) {
        this.pageNum = 1;
        this.itemList = [];
      }
      this.params.journalsYear = item;
      this.getItemList({
        ...this.params,
      });
    },
    async getIncludeList() {
      const resp = await this.$apis.xsjhServe.getIncludeList();
      this.includeList = resp.dbList;
    },
    async getYearList() {
      const resp = await this.$apis.xsjhServe.getYearList();
      this.yearList = resp.yearSet;
    },
    handleAll() {
      this.itemList = [];
      this.filterFlag = false;
      this.params.classifyNumber = null;
      this.params.businessId2 = null;
      // 请求全部
      this.getItemList(this.params);
    },
    handleAll1() {
      this.itemList = [];
      this.filterFlag = false;
      this.params.dataStyle = null;
      // 请求全部
      this.getItemList(this.params);
    },
    handleAll2() {
      this.itemList = [];
      this.filterFlag = false;
      this.params.journalsYear = null;
      // 请求全部
      this.getItemList(this.params);
    },
    handleAll3() {
      this.itemList = [];
      this.filterFlag = false;
      this.params.reportCharge = null;
      // 请求全部
      this.getItemList(this.params);
    },
    handleAll4() {
      this.itemList = [];
      this.filterFlag = false;
      this.params.xsjhStatus = null;
      // 请求全部
      this.getItemList(this.params);
    },
  },
};
